// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11l3p","footer":"styles_footer__Qv_KR"};